import { render, staticRenderFns } from "./NgoInfoForm.vue?vue&type=template&id=ee84f222&"
import script from "./NgoInfoForm.vue?vue&type=script&lang=js&"
export * from "./NgoInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./NgoInfoForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports